<template>
    <van-tag v-if="isPushed" type="primary" size="medium">已推送</van-tag>
    <van-tag v-else type="warning" size="medium">未推送</van-tag>
</template>

<script>
    export default {
        name: "Wp_join_robot_status_tag_model",
        props:{
            isPushed:{type: Boolean, default: false}
        },

    }
</script>

<style scoped>

</style>